import { Button, Card, Divider, Flex, Space, Table } from 'antd';

function SelectTemplateDesktop({ viewModel }) {
  const { token, templates, viewTemplate, copyTemplate, goRegister, goLogin } = viewModel;

  return (
    <Card style={{ width: '500px', position: 'absolute', top: '0%', left: '50%', transform: 'translate(-50%, 0%)', overflow: 'scroll' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" style={{ textAlign: 'center' }}>
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Sỉ Pro - Bán sỉ chuyên nghiệp</span>
          <span>Đăng ký ngay để sở hữu website bán sỉ chuyên nghiệp, tự động hóa mọi thao tác thủ công.</span>
        </Space>

        <Divider orientation="center" style={{ opacity: '0.9' }}>
          Copy website mẫu
        </Divider>

        <Space direction="vertical" style={{ textAlign: 'center' }}>
          <Table
            pagination={false}
            showHeader={false}
            columns={[
              {
                render: (_, record) => record.name,
              },
              {
                render: (_, record) => (
                  <Space>
                    <Button type="link" onClick={() => viewTemplate(record.url)}>
                      Xem
                    </Button>
                    <Button type="link" onClick={() => copyTemplate(record.id)}>
                      Copy
                    </Button>
                  </Space>
                ),
              },
            ]}
            dataSource={templates}
            rowKey="id"
          >
          </Table>
        </Space>

        <Divider orientation="center" style={{ opacity: '0.9' }}>
          Hoặc
        </Divider>

        <Button type="primary" style={{ width: '100%' }} onClick={goRegister}>
          Tạo website mới
        </Button>

        <Flex align="center" justify="center">
          <span>Nếu bạn đã có tài khoản</span>
          <Button type="link" onClick={goLogin}>
            Login
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
}

export default SelectTemplateDesktop;
